/* eslint-disable camelcase */
import { Store } from './store';
import { revalidateCredentials } from '../layout/redux/layoutActions';
import axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';
import { AddAlert } from '../component';
import errorMessages from './errorMessages';

function createHttpClient() {
  const baseURL = process.env.REACT_APP_API_URL;

  const newClient = axios.create({
    baseURL,
    withCredentials: false,
  });
  newClient.interceptors.response.use(
    (response) => {
      return response;
    },

    (err) => {
      const {
        config: { url },
        response: {
          status,
          data: { message },
        },
      } = err;
      if (status === 401 && !url?.includes('platform/manager/public/refresh')) {
        const { RefreshToken } = sessionStorage;
        setTimeout(() => {
          Store.dispatch(revalidateCredentials(RefreshToken));
        }, 500);
      }
      const validMessage = message.includes('Internal Server Error')
        ? 'Ocorreu um erro, tente novamente'
        : message;
      const alertMessage = errorMessages?.[url]?.[status] || validMessage;
      setTimeout(() => {
        console.error(err.response, 'erro api');
        Store.dispatch(AddAlert('warning', alertMessage));
      }, 500);
      throw Error(err.response?.data?.message);
    }
  );

  newClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const { IdToken, user_id, company_id, user_name } = sessionStorage;
      config.headers = {
        ...config.headers,
        authorization: IdToken,
        user_id,
        company_id,
        user_name,
        'Content-Type': 'application/json',
      } as unknown as AxiosRequestHeaders;
      return config;
    }
  );
  return newClient;
}

const api = createHttpClient();

export default api;
